// @ts-nocheck
import { inputStyles as commonInputStyles } from "@store/Themes/common/mixins/formField";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const inputStyles = () => {
    return css`
        ${commonInputStyles()}
        border-color: ${getColor("common.border")};

        &:disabled {
            border-color: ${getColor("common.border")};
        }
    `;
};
